import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-uncommentedvoicepercentage-card',
  templateUrl: './helpbutton-reports-uncommentedvoicepercentage-card.component.html',
  styleUrls: ['./helpbutton-reports-uncommentedvoicepercentage-card.component.scss']
})
export class HelpbuttonReportsUncommentedvoicepercentageCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

  public getRoundedValue() {
    if (this.value) {
      return this.value.toFixed(2);
    } else {
      return 0;
    }
  }

}
